<template>
  <div class="mq-card">
    <div class="mq-body">
      <span class="mq-answer">{{ topItem.answer }}</span>
    </div>
    <span class="mq-time">{{ shortTime }}</span>
  </div>
</template>

<script lang="ts">
/**
 * MatchQuestionsCard - 展示 matchQuestions 气泡的主要内容。
 * 主展示：clicks 最高的一条 answer；同 clicks 时按 createTime 早的优先。
 * 内嵌 HH:mm 时间戳：与 plain-bubble 一致，跟随 answer 文本尾部行内排布。
 * 打开完整答案列表弹窗的 "+N" 徽标由父组件（CustomerContent）渲染在气泡外部。
 */
import { computed, defineComponent, PropType } from 'vue'
import type { MatchQuestionItem } from './matchQuestionsTypes'
import { sortMatchQuestions } from './matchQuestionsTypes'

export default defineComponent({
  name: 'MatchQuestionsCard',
  props: {
    items: {
      type: Array as PropType<MatchQuestionItem[]>,
      required: true,
    },
    timestamp: {
      type: String,
      default: '',
    },
    messageId: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const sortedItems = computed(() => sortMatchQuestions(props.items))
    const topItem = computed(() => sortedItems.value[0] ?? { answer: '', clicks: 0, question: '', queId: 0 })

    // 与 CustomerContent 的 shortTime 保持同源策略：直接切片，避免 new Date() 时区歧义。
    const shortTime = computed(() => {
      const parts = props.timestamp.split(' ')
      if (parts.length < 2) return ''
      return parts[1].slice(0, 5)
    })

    return {
      topItem,
      shortTime,
    }
  },
})
</script>

<style lang="less" scoped>
.mq-card {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  width: 100%;
  min-width: 0;
}

.mq-body {
  flex: 1;
  min-width: 0;
}

.mq-answer {
  display: inline;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--text-primary, #1d2920);
  white-space: pre-line;
  word-break: break-word;
  overflow-wrap: break-word;
}

.mq-time {
  flex-shrink: 0;
  align-self: flex-end;
  white-space: nowrap;
  font-size: 10px;
  line-height: 14px;
  color: var(--text-3);
}
</style>
